import type { ReactNode } from "react";
import { Alert } from "@swot/base-components";
import type { ValidationResult } from "../types/api.types.js";
import { CmtsValidationErrorPanel } from "./CmtsValidationErrorPanel.js";

export function CmtsBackendValidatedForm({ validation, children }: { readonly validation?: ValidationResult | undefined; readonly children?: ReactNode | undefined }) {
  return (
    <section>
      {validation && !validation.isValid ? <Alert title="Backend validation blocked save" tone="warning">Please correct the highlighted fields before saving.</Alert> : null}
      <CmtsValidationErrorPanel fieldErrors={validation?.errors.map((error) => ({ field: error.field, message: error.message, code: error.code }))} />
      {children}
    </section>
  );
}
